<template>
  <v-card flat rounded="lg">
    <v-card-title class="subtitle-1 font-weight-bold"
      >Dados de Referência</v-card-title
    >
    <v-card-text>
      <v-form ref="form" :disabled="editar">
        <v-row>
          <v-col xl="6" lg="6" md="6" cols="12">
            <v-card outlined class="grey lighten-5" rounded="lg">
              <v-card-subtitle class="body-1"
                >Referência bancária</v-card-subtitle
              >
              <v-card-text>
                <v-row dense>
                  <v-col cols="12">
                    <v-textarea
                      label="Observação"
                      rows="3"
                      v-model="clienteManut.refbancaria"
                    ></v-textarea>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      label="Telefone ref bancária"
                      v-model="clienteManut.telrefbancaria"
                      v-mask="'(##) #########'"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col xl="6" lg="6" md="6" cols="12">
            <v-card outlined class="grey lighten-5" rounded="lg">
              <v-card-subtitle class="body-1"
                >Referência comercial</v-card-subtitle
              >
              <v-card-text>
                <v-row dense>
                  <v-col cols="12">
                    <v-textarea
                      label="Observação"
                      rows="3"
                      v-model="clienteManut.refcomercial"
                    ></v-textarea>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      label="Telefone ref comercial"
                      v-model="clienteManut.telrefcomercial"
                      v-mask="'(##) #########'"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapState } from "vuex";
export default {
  computed: mapState("clientes", ["clienteManut", "editar"]),
};
</script>

<style>
</style>